import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AppBadgeNameProps as Props } from './types';

export const AppBadgeName = memo(({ className, appName }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('AppBadgeName', className)}
      sx={SX.root}
    >
      {appName}
      <Icon name="triangle-left-fill" sxx={SX.icon} />
    </Styled.Wrapper>
  );
});

AppBadgeName.displayName = 'AppBadgeName';
